// extracted by mini-css-extract-plugin
export var columnList = "_h6-0";